module.exports = __webpack_public_path__ + "img/kz_pic4.8389eb08.png";